import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { threshold: Number, offset: Number }
  static targets = ["item"]

  connect() {
    this.thresholdValue = this.thresholdValue || 200
    this.offsetValue = this.offsetValue || 100
    this.handleScroll = this.throttle(this.handleScroll.bind(this), 100)
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    this.handleScroll() // Initial check
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll() {
    const shouldShow = window.scrollY > this.thresholdValue
    const target = this.hasItemTarget ? this.itemTarget : this.element
    
    if (shouldShow) {
      target.classList.remove('transform', 'translate-y-full', 'opacity-0', 'hidden')
      target.classList.add('transform', 'translate-y-0', 'opacity-100')
    } else {
      target.classList.add('transform', 'translate-y-full', 'opacity-0')
      target.classList.remove('transform', 'translate-y-0', 'opacity-100')
    }
  }

  throttle(func, limit) {
    let inThrottle
    return function() {
      const args = arguments
      const context = this
      if (!inThrottle) {
        func.apply(context, args)
        inThrottle = true
        setTimeout(() => (inThrottle = false), limit)
      }
    }
  }
}

